import { CustomError } from './customError';
import { isError } from './isErrorLike';
export const ERROR_NAME = 'PanelCreationError';
export class PanelCreationError extends CustomError {
    constructor(originalError) {
        super(ERROR_NAME, 'Failed running create panel function', originalError);
        if (isError(originalError)) {
            this.originalMessage = originalError.message;
        }
    }
}
//# sourceMappingURL=panelCreationError.js.map